import { ShopperAgentSandboxMessageSchema } from "@redotech/redo-shopper-agent-common/sandbox/sandbox-message";
import { TriggerKeySchema } from "@redotech/redo-shopper-agent-common/trigger-definition";
import * as z from "zod";

export const generateSandboxTrigger = {
  name: "generateSandboxTrigger" as const,
  input: z
    .object({
      threadId: z.string().nullable(),
      customerId: z.string().nullable(),
      triggerKey: TriggerKeySchema,
      /** Overrides shopper-agent persona for Recover (and similar) previews. */
      personaName: z.string().trim().min(1).optional(),
      /** Extra merchant guidance layered on the trigger instruction. */
      guidance: z.string().optional(),
      /** Read-only offer for sandbox; stubs a demo code instead of minting. */
      discountId: z.string().trim().min(1).optional(),
    })
    .strict(),
  output: z.object({
    threadId: z.string(),
    messages: z.array(ShopperAgentSandboxMessageSchema),
  }),
};
